/* RESPONSIBLE TEAM: team-automation-foundations */
import type HandoffToExternalAgent from 'embercom/models/operator/visual-builder/step/handoff-to-external-agent';
import StepConfig, { type StepConfigParams } from '../step';

type HandoffToExternalAgentConfigurationParams = Omit<StepConfigParams, 'component'> & {
  integrationId?: number;
};
export default class HandoffToExternalAgentConfiguration extends StepConfig {
  declare step: HandoffToExternalAgent;

  constructor(params: HandoffToExternalAgentConfigurationParams) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-external-agent',
      ...params,
    });
    this.step.integrationId = params.integrationId?.toString();
  }

  get alignment() {
    return 'left' as const;
  }
}
